import {
	ReservationWorkflowRequestStatus,
	ReservationWorkflowRequestType,
} from '../../shared/types'

export const STATUS = {
	new: 'Nová',
	paid: 'Uhrazeno',
	dispatched: 'Auto odjelo',
	finished: 'Uzavřeno (Auto vráceno)',
	cancelled: 'Zrušeno',
} as const

export const STATUS_STYLES: Record<keyof typeof STATUS, string> = {
	new: 'bg-[#f0f9ff] text-[#0086c9]',
	paid: 'bg-[#fdf2fa] text-[#dd2590]',
	cancelled: 'bg-gray-100 text-gray-700',
	finished: 'bg-gray-100 text-gray-600',
	dispatched: 'bg-yellow-100 text-yellow-700',
}

export const STATUS_OPTIONS = Object.entries(STATUS).map(([value, label]) => ({
	value,
	label,
}))

export const REQUEST_TYPE_LABEL: Record<ReservationWorkflowRequestType, string> = {
	handover: 'Výdej',
	return: 'Vratka',
}

export const STATUS_LABEL: Record<ReservationWorkflowRequestStatus, string> = {
	pending: 'Čeká na schválení',
	approved: 'Schváleno',
	rejected: 'Zamítnuto',
}

export const STATUS_BADGE: Record<ReservationWorkflowRequestStatus, string> = {
	pending: 'bg-amber-100 text-amber-700 ring-amber-200',
	approved: 'bg-emerald-100 text-emerald-700 ring-emerald-200',
	rejected: 'bg-rose-100 text-rose-700 ring-rose-200',
}

export const STATUS_BORDER: Record<ReservationWorkflowRequestStatus, string> = {
	pending: 'border-l-amber-500',
	approved: 'border-l-emerald-500',
	rejected: 'border-l-rose-500',
}

export const FIELD_LABELS: Record<string, string> = {
	docs: 'Doklady',
	car_photos: 'Fotky vozidla',
	odo_photo: 'Foto tachometru',
	odo: 'Tachometr',
	fuel_photo: 'Foto palivoměru',
	fuel_photos: 'Fotky palivoměru',
	fuel_gauge: 'Palivoměr',
	fuel_gauge_photo: 'Foto palivoměru',
	fuel_gauge_percent: 'Stav paliva (%)',
	cash: 'Platba hotově',
	cash_amount: 'Platba hotově',
	gate: 'Kontrola výjezdu',
	fuel: 'Stav paliva',
	fuel_level: 'Stav paliva (%)',
	fuel_percent: 'Stav paliva (%)',
	fuel_percentage: 'Stav paliva (%)',
	percent: 'Procenta',
	percentage: 'Procenta',
	hail: 'Kroupy',
	glass: 'Čelní sklo',
	clean_ext: 'Čistota exteriéru',
	clean_int: 'Čistota interiéru',
	gps: 'GPS kontrola',
	docs_back: 'Vrácené doklady',
	trunk_blind: 'Roleta kufru',
	deposit_back: 'Vrácení kauce',
	has: 'Má',
	overlimit: 'Překročení limitu km',
	overlimit_fee: 'Doplatek za překročení limitu km',
	overlimit_diff: 'Ujeto celkem km',
	overlimit_over: 'Počet nadlimitních km',
	diff: 'Ujeto celkem km',
	over: 'Počet nadlimitních km',
	fuel_amount: 'Částka za dotankování',
	glass_amount: 'Částka za čelní sklo',
	hail_amount: 'Částka za kroupy',
	clean_ext_amount: 'Částka za čištění exteriéru',
	clean_int_amount: 'Částka za čištění interiéru',
	trunk_blind_amount: 'Částka za roletu kufru',
	deposit_back_amount: 'Vrácená částka kauce',
	timestamp: 'Čas odeslání',
	date_from: 'Termín od',
	date_to: 'Termín do',
	note: 'Poznámka',
	amount: 'Částka',
	price: 'Cena',
	cost: 'Náklad',
	fee: 'Poplatek',
	charge: 'Poplatek',
	expenses: 'Poplatky',
	extra_expenses: 'Dodatečné poplatky',
	damages: 'Škody',
	damage_items: 'Položky škod',
	charges: 'Poplatky',
	fees: 'Poplatky',
	label: 'Název',
	name: 'Název',
	title: 'Název',
	reason: 'Důvod',
}

export const FIELD_ORDER = [
	'docs',
	'car_photos',
	'odo_photo',
	'odo',
	'fuel_photo',
	'fuel',
	'fuel_level',
	'cash',
	'gate',
	'hail',
	'glass',
	'clean_ext',
	'clean_int',
	'gps',
	'docs_back',
	'trunk_blind',
	'deposit_back',
	'note',
]
